import React, { useEffect, useState, useRef } from "react";
import ReactExport from "react-export-excel";
import { Button } from "antd";
import moment from 'moment';
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;



const Excelldownload = ({ data, from, loading }) => {
  // console.log(data);
  const monthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"];
  let fileName = 'Salary Statement';

  if (loading) {
    return <Button type="ghost" style={{ width: "100%", marginRight: "10px" }}>....Loading</Button>
  } else
    return (
      <ExcelFile element={<Button type="primary" style={{ width: "100%", marginRight: "10px" }}>Download</Button>} filename={fileName}>
        <ExcelSheet data={data} name='Salary Statement'>
          <ExcelColumn label="Department" value="employeeDepartment" />
          <ExcelColumn label="Pin no." value="employeeId" />
          <ExcelColumn label="Name" value="employeeName" />
          <ExcelColumn label="Designation" value="employeeRole" />
          <ExcelColumn label="DBBL Account Number" value="employeebankAccount" />
          <ExcelColumn label="Total Net Payable Amount (TK)" value="totalsalary" />

        </ExcelSheet>
      </ExcelFile>
    );
};

export default Excelldownload;
